import { render, staticRenderFns } from "./yiJianShouKuan.vue?vue&type=template&id=787b520a&scoped=true&"
import script from "./yiJianShouKuan.vue?vue&type=script&lang=js&"
export * from "./yiJianShouKuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787b520a",
  null
  
)

export default component.exports